"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.urlFormatter = exports.transformHotelConfig = exports.saveRecentSearches = exports.prefillSearchCriteria = exports.getRecentSearches = exports.getHotelRedirectionURL = exports.getEndpointURL = exports.getCheckinCheckoutDates = exports.formatEndpointURL = exports.convertStringToDate = exports.constructPassengerData = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _dateFns = require("date-fns");

var _constant = require("./constant");

var _config = require("./config");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var HOTEL_SEARCH_STORAGE_KEY = 'hotelRecentSearches';
var SEARCH_STORE_LIMIT = 10;
var DATE_FORMAT = 'MM/dd/yyyy'; // Need to fetch from calender config.

var REDIRECTION_DATE_FORMAT = 'yyyy-MM-dd';

var urlFormatter = function urlFormatter(source, params) {
  params.forEach(function (n, i) {
    // eslint-disable-next-line no-param-reassign
    source = source.replace(new RegExp("\\{".concat(i, "\\}"), 'g'), n);
  });
  return source;
};

exports.urlFormatter = urlFormatter;

var getRecentSearches = function getRecentSearches() {
  var searches = localStorage.getItem(HOTEL_SEARCH_STORAGE_KEY);

  if (searches != null) {
    searches = JSON.parse(decodeURIComponent(searches));
  }

  return searches || [];
};

exports.getRecentSearches = getRecentSearches;

var saveRecentSearches = function saveRecentSearches(searchCriteria) {
  setTimeout(function () {
    var searches = getRecentSearches();
    searches = searches.filter(function (item) {
      return item.destination.id !== searchCriteria.destination.id;
    });
    var checkin = searchCriteria.checkin,
        checkout = searchCriteria.checkout;
    var saveSearchCritia = {
      destination: searchCriteria.destination,
      date: {
        checkin: (0, _dateFns.format)(checkin, REDIRECTION_DATE_FORMAT),
        checkout: (0, _dateFns.format)(checkout, REDIRECTION_DATE_FORMAT)
      },
      rooms: searchCriteria.rooms
    };
    searches.unshift(saveSearchCritia);
    localStorage.setItem(HOTEL_SEARCH_STORAGE_KEY, encodeURIComponent(JSON.stringify(searches.slice(0, SEARCH_STORE_LIMIT))));
  }, 5);
};

exports.saveRecentSearches = saveRecentSearches;

var childInfantMapping = function childInfantMapping(count, isChildren, roomNumber, childAge) {
  var passMap = [];

  for (var i = 0; i < count; i += 1) {
    var age = 17;

    if (childAge && childAge[i] && childAge[i].value) {
      age = childAge[i].value;
    }

    passMap.push("".concat(roomNumber, "_").concat(isChildren ? age : 1));
  }

  return passMap;
};

var getHotelRedirectionURL = function getHotelRedirectionURL(searchData, redirectionUrl) {
  var language = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en-gb';
  var currency = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'MYR';
  var rooms = 0;
  var passengers = {
    adults: [],
    children: []
  };
  searchData.rooms.forEach(function (room, index) {
    rooms += 1;
    var childsAge = searchData.childsAge && searchData.childsAge[index] ? searchData.childsAge[index] : [];
    passengers.adults.push(room.adult);
    passengers.children = [].concat((0, _toConsumableArray2.default)(passengers.children), (0, _toConsumableArray2.default)(childInfantMapping(room.child, true, index + 1, childsAge)));
  });
  var adult = passengers.adults.join(',');
  var child = passengers.children.length > 0 ? "&children=".concat(passengers.children.join(',')) : '';
  var time = Math.abs(new Date((0, _dateFns.format)(searchData.checkout, DATE_FORMAT)) - new Date((0, _dateFns.format)(searchData.checkin, DATE_FORMAT)));
  var days = Math.ceil(time / (1000 * 3600 * 24));
  var result = "".concat(redirectionUrl, "?destination=").concat(searchData.destination.id, "&rooms=").concat(rooms, "&adults=").concat(adult).concat(child, "&fromDate=").concat((0, _dateFns.format)(searchData.checkin, REDIRECTION_DATE_FORMAT), "&toDate=").concat((0, _dateFns.format)(searchData.checkout, REDIRECTION_DATE_FORMAT), "&days=").concat(days, "&currency=").concat(currency, "&languageId=").concat(language);

  if (searchData.destination && searchData.destination.aa_id && searchData.destination.type === _constant.LOCATION_TYPES.HOTEL) {
    result += "&aaId=".concat(searchData.destination.aa_id);
  }

  return result;
};

exports.getHotelRedirectionURL = getHotelRedirectionURL;

var getCheckinCheckoutDates = function getCheckinCheckoutDates() {
  var extraDaysInCheckin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 7;
  var extraDaysInCheckout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var checkin = new Date();
  var checkout = new Date();
  checkin.setDate(checkin.getDate() + extraDaysInCheckin);
  checkout.setDate(checkout.getDate() + extraDaysInCheckout);
  return {
    checkin: checkin,
    checkout: checkout
  };
};

exports.getCheckinCheckoutDates = getCheckinCheckoutDates;

var convertStringToDate = function convertStringToDate(dateString) {
  return new Date(dateString); // return new Date(formatDate(dateString, format));
};

exports.convertStringToDate = convertStringToDate;

var prefillSearchCriteria = function prefillSearchCriteria(roomConfig) {
  // eslint-disable-next-line no-use-before-define
  return _getRooms(roomConfig);
}; // eslint-disable-next-line no-underscore-dangle


exports.prefillSearchCriteria = prefillSearchCriteria;

var _getRooms = function _getRooms(roomConfig) {
  var room = roomConfig[0].data[0];
  var adults = roomConfig[1].adult[0];
  var childrens = roomConfig[2].child[0];
  var infants = roomConfig[3].infant[0];
  var rooms = []; // eslint-disable-next-line radix

  for (var i = 0; i < parseInt(room.minRooms); i += 1) {
    // eslint-disable-next-line radix
    rooms.push({
      adult: parseInt(adults.min),
      child: parseInt(childrens.min),
      infant: parseInt(infants.min)
    });
  }

  return rooms;
};

var constructPassengerData = function constructPassengerData(passengerData, translations, passengers) {
  var paxData = {};
  passengerData.forEach(function (pax) {
    if (Object.prototype.hasOwnProperty.call(pax, 'data')) {
      var _pax$data$ = pax.data[0],
          minRooms = _pax$data$.minRooms,
          maxRooms = _pax$data$.maxRooms,
          minPassengers = _pax$data$.minPassengers,
          maxPassengers = _pax$data$.maxPassengers,
          maxPassengersPerRoom = _pax$data$.maxPassengersPerRoom;
      paxData = _objectSpread(_objectSpread({}, paxData), {}, {
        minRooms: minRooms,
        maxRooms: maxRooms,
        minPassengers: minPassengers,
        maxPassengers: maxPassengers,
        maxPassengersPerRoom: maxPassengersPerRoom
      });
    }

    if (Object.prototype.hasOwnProperty.call(pax, 'adult')) {
      var _ref = pax && pax.adult.length > 0 ? pax.adult[0] : {},
          min = _ref.min,
          max = _ref.max;

      var adult = {};
      adult.type = 'adult';
      adult.label = translations[0].data[0][_constant.PAX_TRANSLATION_KEYS.ADULT];
      adult.subLabel = translations[0].data[0][_constant.PAX_TRANSLATION_KEYS.ADULT_AGE_LIMIT];
      adult.min = min || 'infant';
      adult.max = max;
      paxData.adult = adult;
    }

    if (Object.prototype.hasOwnProperty.call(pax, 'child')) {
      var _ref2 = pax && pax.child.length > 0 ? pax.child[0] : {},
          _min = _ref2.min,
          _max = _ref2.max;

      var child = {};
      child.type = 'child';
      child.label = translations[0].data[0][_constant.PAX_TRANSLATION_KEYS.CHILD];
      child.subLabel = translations[0].data[0][_constant.PAX_TRANSLATION_KEYS.CHILD_AGE_LIMIT];
      child.min = _min || 0;
      child.max = _max;
      paxData.child = child;
    }

    if (Object.prototype.hasOwnProperty.call(pax, 'infant')) {
      var _ref3 = pax && pax.infant.length > 0 ? pax.infant[0] : {},
          _min2 = _ref3.min,
          _max2 = _ref3.max;

      var infant = {};
      infant.type = 'infant';
      infant.label = translations[0].data[0][_constant.PAX_TRANSLATION_KEYS.INFANT];
      infant.subLabel = translations[0].data[0][_constant.PAX_TRANSLATION_KEYS.INFANT_AGE_LIMIT];
      infant.min = _min2 || 0;
      infant.max = _max2 || 'adult';
      paxData.infant = infant;
    }
  });
  return _objectSpread(_objectSpread({}, paxData), {
    roomOccupancy: passengers
  });
};

exports.constructPassengerData = constructPassengerData;

var getEndpointURL = function getEndpointURL(config, id) {
  var data = config.find(function (ele) {
    return ele.id === id;
  });
  return data ? data.endpointUrl : null;
};

exports.getEndpointURL = getEndpointURL;

var formatEndpointURL = function formatEndpointURL(url, environment) {
  var env = _config.envConfig[environment];
  return url.replace('{gcs_url}', env.GCS_URL).replace('{feature_flag_env}', env.FEATURE_FLAG_ENV).replace('{static_url}', env.STATIC_URL);
};
/**
 * Transforms the configuration object into a new object with boolean, string and array values
 * @param {Object} configResponse - The configuration response from the featureflags
 * @returns {Object} - The transformed configuration object
 */


exports.formatEndpointURL = formatEndpointURL;

var transformHotelConfig = function transformHotelConfig(configResponse) {
  // Check if configResponse or configuration is undefined or null
  if (!configResponse || !configResponse.data || !configResponse.data.configuration) {
    return {}; // Return an empty object if checks fail
  }

  var config = configResponse.data.configuration;
  var transformedConfig = {}; // Iterate through each configuration key

  Object.keys(config).forEach(function (key) {
    var value = config[key]; // Check for boolean values represented as strings

    if (value === 'TRUE' || value === 'FALSE') {
      transformedConfig[key] = value === 'TRUE';
    } else if (value.includes(',')) {
      transformedConfig[key] = value.split(',').map(function (item) {
        return item.trim();
      });
    } else {
      // Keep the value as is if it's neither boolean nor array
      transformedConfig[key] = value;
    }
  });
  return transformedConfig;
};

exports.transformHotelConfig = transformHotelConfig;